import { Injectable } from '@angular/core';
import { of, switchMap } from "rxjs";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { DocViewerActions } from "@store/doc-viewer/doc-viewer.actions";
import { Store } from "@ngrx/store";
import { documentViewActions } from "@store/doc-viewer/document-view/document-view.actions";
import { DocumentViews } from "@store/doc-viewer/doc-viewer.state";

@Injectable()
export class DocumentViewEffects {
	public load$ = createEffect(() => this.actions$.pipe(
		ofType(DocViewerActions.loaded),
		switchMap(() => {
			const documentViewString = localStorage.getItem('document-view') as DocumentViews;
			if (!documentViewString) {
				return of({ type: 'noop' });
			}
			return of(documentViewActions.viewInitialized({ selectedView: documentViewString }));
		})
	)
	);

	public save$ = createEffect(() => this.actions$.pipe(
		ofType(documentViewActions.viewUpdated),
		switchMap((props) => {
			if (props) {
				localStorage.setItem('document-view', props.selectedView);
			}
			return of({ type: 'noop' })
		})
	)
	)

	constructor(
		private actions$: Actions,
		private store: Store
	) {
	}
}
